import * as actionTypes from "./FlexiQuoteType";

const INITIAL_STATE = {
    flexiQuoteList: [],
    docNumList: [],
    customersList: [],
    itemList: [],
    itemModalVisible: false,
    items: [],
    qtCustomersList: [],
    taxList: [],
    flexiQuote: null,
    flexiCurrencyList: [],
    basicFilterData: []
};

const FlexiQuoteReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETLIST:
            return {
                ...state,
                flexiQuoteList: action.payload.list,
            };
        case actionTypes.SETDOCUMENTLIST:
            return {
                ...state,
                docNumList: action.payload.list,
            };
        case actionTypes.SETCUSTOMERLIST:
            return {
                ...state,
                customersList: action.payload.list,
            };
        case actionTypes.SETTAXLIST:
            return {
                ...state,
                taxList: action.payload.list,
            };
        case actionTypes.SETQUOTECUSTOMERLIST:
            return {
                ...state,
                qtCustomersList: action.payload.list,
            };
        case actionTypes.SETITEMLIST:
            return {
                ...state,
                itemList: action.payload,
            };
        case actionTypes.SETFLEXIQUOTE:
            return {
                ...state,
                flexiQuote: action.payload,
            };
        case actionTypes.SETITEMMODALVISIBLE:
            return {
                ...state,
                itemModalVisible: action.payload.data,
            };
        case actionTypes.SETITEMS:
            return {
                ...state,
                items: action.payload.list,
            };
        case actionTypes.SETCURRENCYLIST:
            return {
                ...state,
                flexiCurrencyList: action.payload.list,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                flexiQuote: null,
                itemList: [],
            };
        case actionTypes.SETFLEXIQUOTEBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        default:
            return state;
    }
}

export default FlexiQuoteReducer;